export function preprocessBotMarkdown(text, urlClickText) {
  if (!text) return text;

  const linkText = urlClickText ?? '';
  let result = text.replace(
    /\[\[START_LINK\]\](.*?)\[\[END_LINK\]\]/g,
    (_match, url) => `[${linkText}](${url})`
  );

  // Markdown treats a single newline as a space; hard-break so model line breaks render.
  result = result.replace(/(?<!\n)\n(?!\n)/g, '  \n');

  return result;
}
